// import Services from '@/services/index';
// import VT from '@/store/types';

export default {
  // [VT.LABEL_SET_TAG_DELETE]: ({}, id) => {
  //   return new Promise((resolve, reject) => {
  //     Services.labelSetTags.delete(id).then((data) => {
  //       resolve(data);
  //     }).catch((data) => {
  //       reject(data);
  //     });
  //   });
  // },
};
